module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("chapter one")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Swingin’ Single Meals")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Meals for one are super-popular in HG-land!")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("The best thing about these recipes is that even though they were designed as single-serves, it’s easy to turn them into multi-serving recipes for a group. Just double, triple, or quadruple the ingredient amounts accordingly. Sometimes, you won’t even need a calculator. Yes, it really is that simple.")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" baking sheet, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 5 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("pizza luau")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This pizza is sweet, fun, and DELICIOUS. And don’t even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("think")]), _vm._v(" about limiting it to lunch or snack-time. It’s great for breakfast, too!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 230 calories, 4.5g fat, 808mg sodium, 34g carbs, 6.5g fiber, 9.5g sugars, 17g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons low-fat marinara sauce")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 light English muffin, split into halves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 stick light string cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 slices shaved deli ham (honey or regular), chopped")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 pineapple ring packed in juice, drained and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon chopped red onion")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Preheat oven to 350 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Spread 1 tablespoon sauce onto each muffin half.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Tear string cheese into shreds and roughly chop. Distribute cheese evenly over muffin halves. Top each half with ham, pineapple, and onion.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxHeadA"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra, Extra!")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Left with an open can of pineapple? Check out the "), _c('span', {
    staticClass: "xrefInternal"
  }, [_c('span', {
    attrs: {
      "href": "#/hungrygirl123_ch06#cha71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Island Insanity Burger")])]), _vm._v(" and the "), _c('span', {
    staticClass: "xrefInternal"
  }, [_c('span', {
    attrs: {
      "href": "#/hungrygirl123_ch07#cha82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crazy Pineapple Salmon Teriyaki")])]), _vm._v("!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Place muffin halves on a baking sheet sprayed lightly with nonstick spray. Bake in the oven for 8 to 10 minutes. YUM!!!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/hungrygirl123_bm02#cap02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A pic of this recipe. Yay!")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" mixing bowl, blender or food processor, basic skillet, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 10 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 5 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("am apple scramble")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This isn’t your average morning meal, people. It’s got a whole slew of interesting and delicious stuff in it, and it tastes like scrambled French toast. Yum!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire scramble): 242 calories, 1.75g fat, 655mg sodium, 42g carbs, 6.25g fiber, 15.5g sugars, 17.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 slice light white bread")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons light vanilla soymilk")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ teaspoon cinnamon, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 no-calorie sweetener packets")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 dashes salt, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 cup peeled and finely chopped apple")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 tablespoons old-fashioned oats")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Toast bread. Set aside to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("In a bowl, combine egg substitute, soymilk, vanilla extract, cinnamon, sweetener, and salt. Stir in apple and oats. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Roughly tear bread and place in a blender or food processor. Pulse until reduced to small pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Add egg-apple mixture to the blender/food processor and pulse until just mixed. (Do not over-blend.)")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring a skillet sprayed with nonstick spray to medium heat. Add mixture and prepare as you would scrambled eggs, stirring and cooking for about 5 minutes, until solid bits form and mixture is slightly browned.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("If you like, season with more cinnamon and salt. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/29.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" blender or food processor, bowl, skillet or grill pan with a lid, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 10 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 15 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("tremendous top-shelf turkey burger")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("It’s HUGE and scrumdiddlyumptious—and great on a plate or on a bun.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 184 calories, 6.5g fat, 502mg sodium, 12g carbs, 2g fiber, 4g sugars, 20.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ slice light white bread")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 ounces raw lean ground turkey")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup finely chopped mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 tablespoons finely chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon finely chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon Dijonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon ketchup")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ teaspoon crushed garlic")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Place bread in a blender or food processor, and pulse until you have soft, fluffy breadcrumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("In a bowl, combine breadcrumbs with all other ingredients, and knead by hand until integrated. Form into a nice, big patty about ¾-inch thick.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring a skillet or grill pan sprayed with nonstick spray to medium heat. Place patty in the skillet/grill pan, cover, and cook for 5 to 7 minutes per side, until patty is cooked through. (Pssst…flip carefully.)")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Serve on a plate, on a bun, over lettuce…whatever!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" bowl, skillet or grill pan with a lid, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 5 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 15 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("outside-in cheeseburger patty")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("We’ve boldly placed Laughing Cow wedges where they’ve never been placed before. We’re adventurous like that.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 179 calories, 6.5g fat, 502mg sodium, 1.5g carbs, 0g fiber, 1g sugars, 26.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("4 ounces raw extra-lean ground beef")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash salt, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash black pepper, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 wedge The Laughing Cow Light Original Swiss cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Combine all ingredients except cheese in a bowl. Add as much salt and pepper as you like. Knead mixture by hand until integrated.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Form into a ball and, using your thumb, make a large, hollow indentation in the ball (past the center but not all the way through). Fill the hole with cheese and squeeze the meat to seal, making sure no cheese is exposed. Flatten slightly into a thick patty.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring a skillet or grill pan sprayed with nonstick spray to medium-high heat. Place patty in the skillet/grill pan, cover, and cook for 4 to 7 minutes per side, depending on how well done you like your burger. Heads Up: Don’t press on the patty with your spatula (your burger might ooze cheese!).")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Serve however you like your burger…We like ours with ketchup and pickles between giant leaves of lettuce!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" large microwave-safe mug, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 5 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 5 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("cheesy green eggs ’n hamwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Do not fear eggs that have a green hue. They’re just, um, different. Heads up: If you use egg whites instead of (yellow) egg substitute, your eggs will be alarmingly green. Consider yourself warned. (Pssst…Kids LOVE this recipe!)")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 255 calories, 4.5g fat, 1,319mg sodium, 25g carbs, 5.75g fiber, 3g sugars, 30g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 light English muffin, split into halves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 ounces (about 4 slices) 97 to 98% fat-free ham")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 drops green food coloring")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 wedge The Laughing Cow Light Original Swiss cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional: salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Toast muffin halves until they’re as crispy as you like. Place ham in a large microwave-safe mug, and microwave just until warm, about 20 seconds. Evenly top muffin halves with ham, and then set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Spray the microwave-safe mug lightly with nonstick spray. Add egg substitute, food coloring, and cheese wedge, breaking cheese into pieces as you add it. Mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Microwave for 1 minute. Stir and microwave for an additional 45 to 60 seconds, until fully cooked. Stir again.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Evenly distribute eggs between the ham-topped muffin halves. If you like, sprinkle with some salt. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/33.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" large microwave-safe mug, nonstick spray, baking sheet, small microwave-safe bowl")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 15 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 15 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha06"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("smothered pepperoni pizza breakfast burrito")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("For serious foodies who know it’s never too early in the day to enjoy delicious, saucy, cheesy, pizza goodness.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire burrito): 284 calories, 6.5g fat, 1,078mg sodium, 31g carbs, 7.5g fiber, 4.5g sugars, 30g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons chopped green bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 burrito-size flour tortilla with about 110 calories")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash garlic powder, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("6 slices turkey pepperoni, halved")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 stick light string cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 tablespoons canned crushed tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 teaspoon reduced-fat Parmesan-style grated topping")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional: salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Preheat oven to 350 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Spray a large microwave-safe mug with nonstick spray. Add egg substitute, bell pepper, and onion, and microwave for 1 minute.")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/34.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Stir gently, and then microwave for another 45 to 60 seconds, until scramble is just set.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Warm tortilla for about 10 seconds in the microwave. Spread diced tomatoes down the center of the tortilla, and sprinkle with garlic powder and black pepper. Top with turkey pepperoni, followed by egg scramble.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Tear string cheese into shreds and place on top of the eggs. Wrap tortilla up like a burrito, folding the sides in first, and then rolling it up from the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Place burrito seam-side down on a baking sheet sprayed with nonstick spray, and bake in the oven for 8 to 10 minutes, until crispy. Meanwhile, place crushed tomatoes in a microwave-safe bowl and heat in the microwave. If you like, season to taste with garlic powder and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Plate your burrito and top with crushed tomatoes and grated topping. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter"
  }, [_vm._v("For Weight Watchers "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("POINTS")])]), _vm._v("® values and photos of all the recipes in this book, check out "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com/book",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com/book")])]), _vm._v(".")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" bowls, basic skillet, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 10 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 5 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha07"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("totally thai chicken lettuce cups")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Just like the stuff you find at your favorite restaurants—without all the hidden calories and fat grams. SCORE!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 227 calories, 4.5g fat, 875mg sodium, 21g carbs, 3g fiber, 12.5g sugars, 23g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¾ cup peeled and diced cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 scallions, cut into ½-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons shredded carrot")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons seasoned rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon chopped cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash crushed red pepper, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 ounces raw boneless skinless lean chicken breast, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1½ tablespoons Thai peanut salad dressing or sauce (low in fat with about 35 calories per tablespoon)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 leaves romaine, butter, or green leaf lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional garnishes: lime wedges, sesame seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("In a bowl, combine cucumber, scallions, carrot shreds, rice vinegar, cilantro, and crushed red pepper. Mix well and refrigerate until you’re ready to assemble your cups.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring a skillet sprayed with nonstick spray to medium-high heat. Add chicken and sprinkle with garlic powder. Cook chicken, stirring occasionally, until browned and cooked through, about 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Place chicken and peanut dressing or sauce in a bowl and toss to coat. Remove veggie mixture from the fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("To assemble, evenly distribute the veggie mixture and the chicken among the lettuce “cups.” If you like, finish with a squirt of lime juice and a sprinkle of sesame seeds. Chomp chomp!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" bowl")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha08"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("lucky four-leaf salad with feta and apples")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Ooooh, look at us. We’ve created a classy, refreshing, and totally guilt-free salad with fruit and cheese. Yay!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire salad): 213 calories, 8g fat, 552mg sodium, 29.5g carbs, 6.5g fiber, 16.5g sugars, 10g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 Fuji apple")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 cups 3-lettuce blend bagged lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 cup spinach leaves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup crumbled reduced-fat feta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup thinly sliced red onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon thinly sliced dry-roasted almonds")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional: freshly ground black pepper, light vinaigrette dressing or another low-calorie dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Cut apple into quarters and remove the core, seeds, and stem. Thinly slice, and then cut the slices in half widthwise.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Toss all ingredients together in a bowl. Add some pepper and dressing if you like, but this salad’s so flavorful you may not even need ’em. Enjoy!!!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" bowl, plate, baking sheet, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 15 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha09"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("honey mustard pretzel-coated chicken fingers")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Confession time! I’m a little obsessed with these. They actually remind me of the little Weaver chicken drummies I ate when I was a kid. They had bones back then, and weren’t made with pretzels, and were actually NOTHING like these. But the sweet, salty flavor of this recipe is reminiscent of those little drummettes…and I LOVE IT!!!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 349 calories, 2.5g fat, 928mg sodium, 39g carbs, 1g fiber, 13.5g sugars, 37g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 tablespoons honey mustard")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("5 ounces raw boneless skinless lean chicken breast, cut into 4 strips")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 dashes salt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 dashes black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 ounce (about 10 twists) hard salted pretzels, finely crushed")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 teaspoons granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Preheat oven to 375 degrees.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Mix honey mustard and egg substitute together in a small bowl. Season chicken strips with salt and pepper, and then submerge in the mustard-egg mixture. Set aside to marinate for at least 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Mix crushed pretzels with sugar and spread mixture out on a plate. Spray a baking sheet with nonstick spray.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Thoroughly coat chicken strips with the pretzel-sugar mixture, and then transfer to the baking sheet. (Discard excess mustard-egg mixture.) Mist the tops of the strips with nonstick spray.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bake in the oven for about 20 minutes, flipping chicken halfway through baking, until chicken is cooked through.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Eat and enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" bowl, basic skillet, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 15 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("santa fe cheesy chicken stir-fry")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Love cheese, chicken, and southwestern flavors? Let the stir-frying begin!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 256 calories, 2g fat, 693mg sodium, 19.5g carbs, 3.25g fiber, 4.5g sugars, 38.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("4 ounces raw boneless skinless lean chicken breast, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons canned black beans, drained and rinsed")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon chopped cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ teaspoon lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 dashes ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 dashes black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup frozen corn")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup thinly sliced onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup thinly sliced red bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup shredded fat-free cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup chopped tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("In a bowl, combine chicken, beans, cilantro, lime juice, chili powder, salt, cumin, and black pepper. Mix well and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring a skillet sprayed with nonstick spray to medium-high heat. Add corn, onion, and bell pepper. Stirring frequently, cook for 4 to 5 minutes, until onion softens.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxHeadA"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra, Extra!")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Got black beans? Whip up the "), _c('span', {
    staticClass: "xrefInternal"
  }, [_c('span', {
    attrs: {
      "href": "#/hungrygirl123_ch06#cha74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bursting Burrito Bowl")])]), _vm._v(" or the "), _c('span', {
    staticClass: "xrefInternal"
  }, [_c('span', {
    attrs: {
      "href": "#/hungrygirl123_ch11#cha135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fiesta Bites")])]), _vm._v("!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Add chicken mixture and, stirring occasionally, cook for 5 minutes, or until chicken is cooked through.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Add cheese and tomatoes and stir until cheese starts to melt. Enjoy immediately!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" baking sheet, nonstick spray, bowl")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 10 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 5 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("totally terrific tuna melt")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The perfect tuna salad is easier than you think. Just swap out the usual fatty mix-ins for pickles, onions, and fat-free Greek yogurt. SO SIMPLE!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 298 calories, 3g fat, 1,379mg sodium, 31.5g carbs, 6.25g fiber, 4g sugars, 39g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 light English muffin, split into halves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("3 ounces (about 1/3 cup) albacore tuna packed in water, drained and flaked")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon Dijonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon fat-free plain Greek yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon chopped dill pickle")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 teaspoon dried minced onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Squirt of lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Dash black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 slices plum tomato")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 slices fat-free cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Preheat broiler.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Lightly toast muffin halves. Set aside on a baking sheet lightly sprayed with nonstick spray.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("In a small bowl, combine tuna, Dijonnaise, yogurt, pickle, onion, lemon juice, garlic powder, and pepper. Mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Evenly distribute tuna mixture between the muffin halves. Top each with a slice of tomato followed by a slice of cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Broil for 1 to 2 minutes, until cheese melts.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Plate your open-faced tuna melt and eat up!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Alternative!")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_vm._v("Feel free to use fat-free mayo instead of Greek yogurt in this recipe.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" large sealable plastic bag, meat mallet or a heavy can, oven-safe skillet, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 15 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 15 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha12"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("pizza-fied chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Oooooh…This is like an oddly shaped pizza with chicken as the crust. So cool!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 282 calories, 5.75g fat, 868mg sodium, 10g carbs, 2g fiber, 4.5g sugars, 44g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup canned crushed tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 stick light string cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("5 ounces raw boneless skinless lean chicken breast")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon salt, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/8 teaspoon black pepper, or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup diced green bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ cup sliced mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons diced onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("4 slices turkey pepperoni, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 teaspoon reduced-fat Parmesan-style grated topping")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional seasonings and toppings: crushed red pepper, oregano, basil")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Preheat broiler.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("If you like, season crushed tomatoes to taste with salt, black pepper, and optional seasonings. Set aside. Tear string cheese into shreds, roughly chop, and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Place chicken in a large sealable plastic bag and, removing as much air as possible, seal the bag. Carefully pound chicken through the bag with a meat mallet or a heavy can, until it is uniformly about ½-inch thick. Evenly sprinkle both sides of the chicken with the garlic powder, onion powder, salt, and black pepper. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring an oven-safe skillet sprayed with nonstick spray to medium heat on the stove. Add bell pepper, mushrooms, and onion and cook until softened, about 4 to 6 minutes. Remove veggies and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Remove skillet from heat, re-spray, and return to medium heat. Add chicken and cook for about 3 minutes per side, until cooked through.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Top chicken with crushed tomatoes, string cheese, veggies, and turkey pepperoni.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Place skillet under the broiler for 2 to 3 minutes, until cheese softens and pepperoni becomes crisp.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Plate your pizza-fied chicken and sprinkle with grated topping. If you like, sprinkle with optional toppings. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxHeadA"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Tip!")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_vm._v("If you’re not sure if the handle of your skillet is oven-safe, wrap the handle with aluminum foil before heating it.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" bowl, skillet with a lid, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 15 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha13"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("chop-chop beef stir-fry")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Tastes like delicious takeout with way fewer calories and fat grams. It’s sweet, spicy, and REALLY tasty!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 293 calories, 6.5g fat, 759mg sodium, 26g carbs, 7.5g fiber, 7g sugars, 35g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup fat-free beef broth")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon reduced-sodium/lite soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon cornstarch")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("4 ounces raw lean beefsteak filet, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ tablespoon chopped garlic")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("¼ teaspoon crushed red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 cups broccoli florets")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 cup sugar snap peas")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 cup sliced mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 tablespoons chopped scallions")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional: salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Combine beef broth, soy sauce, and cornstarch in a bowl, and mix until cornstarch dissolves. Add beef, garlic, and crushed red pepper. Toss to coat and let marinate in the fridge for 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring a skillet sprayed with nonstick spray to medium-high heat. Add broccoli, sugar snap peas, mushrooms, scallions, and ¼ cup of the marinade from the beef. Cook for about 5 minutes, stirring occasionally, until broccoli softens.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Add beef and remaining marinade, and cook until browned and cooked through, about 3 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Reduce heat to low, cover, and let simmer for 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Serve it up and, if you like, season to taste with salt. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" basic skillet or grill pan, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 5 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha14"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("too-beautiful turkey burger")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This swap for the Ruby Tuesday classic has Swiss cheese, sautéed mushrooms, and more. Plus, it saves you a ridiculous amount of fat and calories. Go, us!")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 305 calories, 11.5g fat, 578mg sodium, 22g carbs, 4g fiber, 4g sugars, 32g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 small light hamburger bun (about 80 calories)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 small lettuce leaves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("2 slices tomato")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 raw plain lean turkey burger patty")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 slice 2% milk Swiss cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup sliced baby bella mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional: pickles, ketchup, mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Split bun in half, and toast lightly. Place lettuce and tomato on the bottom half of the bun. If you like, add a few pickle chips, a squirt of ketchup, and some mustard. Set aside.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Cook turkey patty in a skillet or grill pan sprayed with nonstick spray (refer to packaging for specific time and cooking temperature).")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Once cooked, place patty on the bottom half of the bun, and immediately top with cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Remove skillet/grill pan from heat and re-spray with nonstick spray. Over medium heat, cook mushroom slices until tender, about 3 minutes, stirring occasionally.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Place mushrooms over the cheese-topped patty. Top with the other half of the bun and enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/hungrygirl123_bm02#cap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A pic of this recipe. Yay!")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Alternative!")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_vm._v("Can’t find 80-calorie buns? No worries! Get the lowest-calorie ones you can find, and adjust the nutritionals for this recipe accordingly.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/51.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" basic skillet, nonstick spray, microwave-safe bowl")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 10 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("bowling for pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fun, filling, unique, and delicious. We’ll take our pizza any way we can, and this one has no crust! Cool, huh?")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire bowl): 284 calories, 7g fat, 1,025mg sodium, 28.5g carbs, 9.25g fiber, 11g sugars, 30.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1/3 cup canned crushed tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 stick light string cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 cup sliced mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 cup sliced green bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup sliced onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 Boca Original Meatless Burger (Vegan), thawed and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 teaspoon reduced-fat Parmesan-style grated topping")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("8 slices turkey pepperoni, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 tablespoon sliced black olives")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional: salt, black pepper, garlic powder, onion powder, crushed red pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("If you like, season crushed tomatoes to taste with optional ingredients. Set aside. Tear string cheese into shreds, roughly chop, and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("In a skillet sprayed with nonstick spray, cook mushrooms, bell pepper, and onion over medium heat until softened, about 3 to 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Add chopped Boca patty, diced tomatoes, and crushed tomatoes, and continue cooking until heated through, about 3 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Transfer to a microwave-safe bowl and immediately sprinkle with string cheese, grated topping, turkey pepperoni, and olives.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Microwave for about 30 seconds, just long enough to heat and soften the cheese. Enjoy!!!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter"
  }, [_vm._v("For more recipes, tips & tricks, food finds, and MORE, sign up for FREE daily emails at "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com")])]), _vm._v("!")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You’ll Need:")]), _vm._v(" bowl, basic skillet, nonstick spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prep:")]), _vm._v(" 10 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent2",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cook:")]), _vm._v(" 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    attrs: {
      "id": "cha16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("sausage, peppers, and onions italia")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Try this decadent Italian classic served over Tofu Shirataki noodles for added chewing fun.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PER SERVING")]), _vm._v(" (entire recipe): 295 calories, 8.25g fat, 905mg sodium, 35g carbs, 7.25g fiber, 18g sugars, 22g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ cup canned crushed tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("½ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1¼ cups thickly sliced onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1½ cups thickly sliced red and green bell peppers")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("1 precooked 3-ounce chicken or meatless sausage link with 8g fat or less, sliced into ½-inch rounds")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_vm._v("Optional: salt and black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Combine crushed tomatoes, oregano, and garlic powder in a bowl, and stir well. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Bring a skillet sprayed with nonstick spray to medium-high heat. Add onion and cook for 2 minutes. Add bell peppers and continue to cook, stirring occasionally, for 2 to 4 minutes, until veggies are slightly softened.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Add sausage and cook for an additional 1 to 2 minutes, until heated.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Add tomatoes and stir. Once heated, season to taste with salt and black pepper (or not). Now chew!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxHeadA"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Tip!")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent"
  }, [_vm._v("If using frozen sausage, do not thaw completely. This will make it easier to slice.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/55.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-506538ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hungrygirl123_ch01.vue
// module id = 90
// module chunks = 0